import React from 'react';
import { motion } from 'framer-motion';

const ProductSkeleton = ({ index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className="relative bg-white rounded-[2rem] sm:rounded-[2.5rem] p-3 sm:p-4 shadow-sm border border-slate-50 flex flex-col h-full overflow-hidden"
    >
      {/* Product Image Skeleton */}
      <div className="relative aspect-[4/5] rounded-[2rem] bg-slate-100 mb-6 animate-pulse overflow-hidden">
         {/* Shimmer effect Overlay */}
         <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" />
      </div>

      {/* Content Area Skeleton */}
      <div className="px-2 flex-1 flex flex-col space-y-3">
        {/* Title */}
        <div className="h-6 w-3/4 bg-slate-100 rounded-lg animate-pulse" />
        
        {/* Description Lines */}
        <div className="space-y-2">
          <div className="h-3 w-full bg-slate-50 rounded-lg animate-pulse" />
          <div className="h-3 w-5/6 bg-slate-50 rounded-lg animate-pulse" />
        </div>

        {/* Pricing & Cart Bar */}
        <div className="flex items-center justify-between mt-auto pt-4">
          <div className="h-8 w-24 bg-slate-100 rounded-lg animate-pulse" />
          <div className="w-12 h-12 rounded-full bg-slate-100 animate-pulse" />
        </div>
      </div>
      
      {/* CSS for shimmer if not already in global CSS, but tailwind pulse is usually enough */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}} />
    </motion.div>
  );
};

export default ProductSkeleton;
